interface BrandLogoProps {
  small?: boolean;
}

export function BrandLogo({ small = false }: BrandLogoProps): JSX.Element {
  return (
    <img
      className={`brand-logo${small ? ' brand-logo--small' : ''}`}
      src="/logo-sense-ai.png"
      alt="Sense AI"
    />
  );
}
